import {MeinImage} from '@components/@shared/Image/MeinImage';
import {CdnImageSizes} from '@config/cdnImageSizes';
import {useVideoPlayerState} from '../useVideoPlayer';
import styles from './VideoPlayerPoster.module.css';

interface IProps {
    poster?: string | null;
    size: keyof typeof CdnImageSizes;
}

export const VideoPlayerPoster = ({poster, size}: IProps) => {
    const isStarted = useVideoPlayerState(s => s.isStarted);

    if (!poster || isStarted) {
        return null;
    }

    return (
        <div className={styles.container}>
            <MeinImage
                src={poster}
                size={size}
                alt="Video Poster"
                className={styles.image}
            />
        </div>
    );
};
